module.exports = __webpack_public_path__ + "media/images/benefit-1a21095a7c6bfb78d8a6ae97165fed15.png";